require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-world-bank-funny-math.json") })
        }
      }, "path---en-us-update-world-bank-funny-math");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-world-bank-funny-math!./.cache/json/en-us-update-world-bank-funny-math.json
// module id = 875
// module chunks = 231608221292675